import { ComboBoxItem } from "./ComboBoxItem";
import { ComboBoxRoot } from "./ComboBoxRoot";
export let ComboBoxProps;
export const ComboBox = {
  /**
   * Root component for the ComboBox.
   *
   * ```jsx
   * <ComboBox.Root label="Type something">
   *   <ComboBox.Item>Item 1</ComboBox.Item>
   *   <ComboBox.Item>Item 2</ComboBox.Item>
   *   <ComboBox.Item>Item 3</ComboBox.Item>
   * </ComboBox.Root>;
   * ```
   */
  Root: ComboBoxRoot,
  /** Item component for the ComboBox. Must be a child of `ComboBox.Root`. */
  Item: ComboBoxItem
};
//# sourceMappingURL=ComboBox.js.map